import { BuildingOfficeIcon, CheckCircleIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import { connect } from 'react-redux';
import { Navigate } from "react-router-dom";

const FinalConfirmation = ({
    company,
    closeModal,
}) => {
    return (
        <>
            <div style={{ color: '#ea611c', textAlign: 'center', margin: 'auto', paddingTop: '5rem', width: '15rem', position: 'relative' }}>
                <BuildingOfficeIcon style={{ background: 'white', borderRadius: '100rem', border: 'solid 1rem' }} />
                <CheckCircleIcon style={{ position: 'absolute', background: 'white', borderRadius: '5rem', height: '7.5rem', right: 0, top: '13.75rem' }} />
                <div style={{ color: 'rgb(35, 42, 50' }}>
                    <h4>{company.name}</h4>
                    <h5>has been created and added to your list!</h5>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                <div
                    className="btn btn-success"
                    onClick={closeModal}
                >
                    <MagnifyingGlassIcon style={{ height: "1.5em", float: "left" }} />
                    <div style={{ float: "left", paddingLeft: 5 }}>Switch Company</div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        company: state.company?.newCompany
    }
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalConfirmation)